// eslint-disable-next-line @tseslint/typedef
export const SET_PASSWORD_TOKENS = {
  INVALID_CURRENT_PASSWORD: "invalid-current-password",
  // Currently returned when new password was used before
  PASSWORD_POLICY_ERROR: "password-policy-error"
} as const;
export type SetPasswordToken = typeof SET_PASSWORD_TOKENS[keyof typeof SET_PASSWORD_TOKENS];

const allowedTokens: string[] = Object.values(SET_PASSWORD_TOKENS) as SetPasswordToken[];

/**
 * Runtime type guard to check if a value is one of the defined SetPasswordToken literals.
 *
 * @param token – The value to validate.
 * @returns `true` if `token` is exactly one of the SetPasswordToken strings; otherwise `false`.
 */
export function isSetPasswordToken (token: unknown): token is SetPasswordToken {
  return typeof token === 'string' && allowedTokens.includes(token as SetPasswordToken);
}
